/* eslint-disable max-len */
export const IconBack = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.5 12L19.5 12" stroke="#202124" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.5498 18.0246L4.4998 12.0006L10.5498 5.97559" stroke="#202124" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
